import dataroomProjectCategoryIcon from '@/assets/img/project/dataroom-project-category.svg'
import projectCategoryIcon from '@/assets/img/project/project-category.svg'
import {
  ROOM_DOCUMENTS_ROUTE_NAME,
  ROOM_MEMBERS_ROUTE_NAME,
  ROOM_ROUTE_TYPES,
  SIGNING_CHECKLIST_ROUTE_NAME,
} from '@/router/routerData'

function getRoomColorTheme (room) {
  return room?.isDataroom
    ? 'deep-purple'
    : 'light-blue'
}

function getRoomCount (room, countName) {
  const NO_COUNTER_VALUE = '-'
  const { countsForRoom, countsForUser } = room

  if (countsForRoom?.[countName] >= 0) {
    return countsForRoom[countName]
  }

  if (countsForUser?.[countName] >= 0) {
    return countsForUser[countName]
  }

  return NO_COUNTER_VALUE
}

function getRoomIcon (room) {
  return room?.isDataroom
    ? dataroomProjectCategoryIcon
    : projectCategoryIcon
}

/**
 * Get roomType route param
 * @param {Object} room The room object to build route path for
 * @returns {typeof ROOM_ROUTE_TYPES[keyof typeof ROOM_ROUTE_TYPES]} A string to use as roomType param in the room route path
 */
function getRoomRouteType (room) {
  return room?.isDataroom
    ? ROOM_ROUTE_TYPES.DATAROOM
    : ROOM_ROUTE_TYPES.PROJECT
}

function getRoomDefaultRoute (room) {
  let defaultRouteName = ROOM_MEMBERS_ROUTE_NAME

  if (room.isDataroom) {
    defaultRouteName = ROOM_DOCUMENTS_ROUTE_NAME
  } else if (room.hasDocumentToSign) {
    defaultRouteName = SIGNING_CHECKLIST_ROUTE_NAME
  }

  return {
    name: defaultRouteName,
    params: {
      roomType: getRoomRouteType(room),
      mnemo: room.mnemo,
    },
  }
}

export {
  getRoomColorTheme,
  getRoomCount,
  getRoomIcon,
  getRoomRouteType,
  getRoomDefaultRoute,
}
